import { render } from "./ItemCategoryFullWidth.vue?vue&type=template&id=6a67f4de"
import script from "./ItemCategoryFullWidth.vue?vue&type=script&lang=js"
export * from "./ItemCategoryFullWidth.vue?vue&type=script&lang=js"

import "./ItemCategoryFullWidth.vue?vue&type=style&index=0&id=6a67f4de&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__